import React from "react";
import ReactDOM from "react-dom";
import Routes from "./femi-vass/routes";
import "./femi-vass/style/default.css";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(<Routes />, document.getElementById("root"));

serviceWorker.unregister();
